"use strict";
angular.module("regionalOfficialModule", ['tManageMentServiceModule'])
    .controller("regionalOfficialCtrl", ["$scope", "$modalInstance", "tManageMentService", "trsHttpService", "item", "Upload", "editPictureService", "modalDialog", "$validation", function($scope, $modalInstance, tManageMentService, trsHttpService, item, Upload, editPictureService, modalDialog, $validation) {
        initStatus();
        initData();

        /** [initStatus description:初始化关注官员状态] */
        function initStatus() {
            $scope.status = {
                leaderPic: "",
                leaderName: "",
                leaderPosition: "",
                leaderLevantinfId: "", //领导ID
                leaderTitle: item === undefined ? "新增官员" : "编辑官员",
                aditPicture: false
            };
            $scope.isShowImg = false;
            if (item != undefined) {
                $scope.status.leaderPic = item.LEADERPICTURE;
                $scope.status.leaderName = item.LEADERNAME;
                $scope.status.leaderPosition = item.LEADERPOSITION;
                $scope.status.leaderLevantinfId = item.TENANTRELEVANTINFOID;
                if ($scope.status.leaderPic === '') {
                    $scope.isShowImg = false;
                } else {
                    $scope.isShowImg = true;
                }
            }
        }

        /** [initData description:初始化数据] */
        function initData() {
            $scope.params = {
                "serviceid": "mlf_tenant",
                "methodName": "saveTenantRelevantInfo",
            };
            // checkIsTenantAdmin();
        }

        /** [checkIsTenantAdmin description: c查询是否是租户管理员] */
        // function checkIsTenantAdmin() {
        //     var params = {
        //         "serviceid": "mlf_tenant",
        //         "methodName": "CheckIsTenantAdmin",
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data){
        //         console.log(data);
        //     });
        // }
        /** [changeLeaderInfo description:编辑国家管理员] */
        function changeLeaderInfo() {
            var changeLeaderInfo;
            if ($scope.status.aditPicture) {
                changeLeaderInfo = '[{"NAME":"' + $scope.status.leaderName + '", "POSITION":"' + $scope.status.leaderPosition + '", "PERPICTURE":"' + $scope.status.leaderPic + '","TENANTRELEVANTINFOID":"' + item.TENANTRELEVANTINFOID + '"}]';
            } else {
                changeLeaderInfo = '[{"NAME":"' + $scope.status.leaderName + '", "POSITION":"' + $scope.status.leaderPosition + '","TENANTRELEVANTINFOID":"' + item.TENANTRELEVANTINFOID + '"}]';
            }
            var changeparams = {
                "serviceid": "mlf_tenant",
                "methodName": "saveTenantRelevantInfo",
                // "TENANTRELEVANTINFOID": item.TENANTRELEVANTINFOID,
                "LEADERINFO": changeLeaderInfo
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), changeparams, 'post').then(function(data) {
                $modalInstance.close(data);
            });
        }

        /** [changeHeadPortrait description：点击替换头像或者上传头像] */
        $scope.changeHeadPortrait = function(files, file, newFiles) {
            var imgType = ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
                fileType = newFiles[0].name.substr(newFiles[0].name.lastIndexOf('.') + 1).toLowerCase();
            if (imgType.indexOf(fileType) < 0) {
                modalDialog.alertType('格式不支持', '', 'warning', false);
                return;
            }
            Upload.upload({
                url: "/wcm/openapi/uploadImage",
                data: {
                    file: newFiles[0]
                },
            }).then(function(res) {
                if (item != undefined) {
                    $scope.status.aditPicture = true;
                }
                if (res.data.error != '请确认文件格式是否正确!') {
                    tManageMentService.uploadIsicon(res).then(function(data) {
                        $scope.status.leaderPic = data.imgSrc;
                        $scope.params.PERPICTURE = data.imgSrc;
                        $scope.isShowImg = true;
                    });
                } else {
                    modalDialog.alertType('格式不支持', '', 'warning', false);
                }
            });
        };

        function newCreatLeader() {
            if ($scope.status.leaderPic === '') {
                modalDialog.alertType('', '请先选择领导人头像', 'info', false)
            } else {
                var leaderInfo = '[{"NAME":"' + $scope.status.leaderName + '", "POSITION":"' + $scope.status.leaderPosition + '", "PERPICTURE":"' + $scope.status.leaderPic + '","TENANTRELEVANTINFOID":"' + 0 + '"}]';
                var newparams = {
                    "serviceid": "mlf_tenant",
                    "methodName": "saveTenantRelevantInfo",
                    //"TENANTRELEVANTINFOID": 0,
                    "LEADERINFO": leaderInfo
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), newparams, 'post').then(function(data) {
                    $modalInstance.close(data);
                });
            }
        }

        /** [confirm description: 弹框确定按钮] */
        $scope.confirm = function() {
            if (item != undefined) {
                $validation.validate($scope.leaderInfoToKnow).success(function() {
                    changeLeaderInfo();
                }).error(function() {
                    modalDialog.alertType('保存失败', "请检查填写项", "error", false);
                });
            } else {
                $validation.validate($scope.leaderInfoToKnow).success(function() {
                    newCreatLeader();
                }).error(function() {
                    modalDialog.alertType('保存失败', "请检查填写项", "error", false);
                });
            }
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);